import React, {createContext, useState, useEffect, useContext} from 'react';
import {collection, onSnapshot, query, orderBy} from 'firebase/firestore';
import sortBy from 'lodash/sortBy';

import {db} from '-/firebase';
import {processRawDocs, hasPermission} from '-/data/utils';
import {UserContext} from '-/contexts/User';
import {hasFeature} from '-/features';
import {resilientSnapshot} from '-/data/errorReporting';

export const FileCategoriesContext = createContext({
    fileCategories: [],
    loading: true
});

export function FileCategoriesProvider({children}) {
    const [fileCategories, setFileCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const {currentUser} = useContext(UserContext);

    useEffect(() => {
        if (!currentUser || !hasFeature('files') || !hasPermission(currentUser, 'files.read')) {
            setFileCategories([]);
            setLoading(false);
            return;
        }

        const ref = collection(db, 'fileCategories');
        const q = query(ref, orderBy('order', 'asc'));
        return resilientSnapshot(onError => onSnapshot(q, snapshot => {
            setFileCategories(sortBy(processRawDocs(snapshot), 'order'));
            setLoading(false);
        }, onError), 'FileCategories.fileCategories', () => setLoading(false));
    }, [currentUser]);

    return (
        <FileCategoriesContext.Provider value={{fileCategories, loading}}>
            {children}
        </FileCategoriesContext.Provider>
    );
}
